import type { FC, ReactNode } from "react";

import { CustomIndustriesEmptyState, SharedIndustriesEmptyState } from "./EmptyStates";
import { LockedState } from "./LockedState";

interface ITabContentProps {
    isLocked: boolean;
    hasItems: boolean;
    isCustom?: boolean;
    children: ReactNode;
}

export const TabContent: FC<ITabContentProps> = ({ isLocked, hasItems, isCustom, children }) => {
    if (isLocked) {
        return (
            <>
                <LockedState />
                {hasItems ? children : null}
            </>
        );
    }

    if (!hasItems && isCustom) {
        return <CustomIndustriesEmptyState />;
    }

    if (!hasItems) {
        return <SharedIndustriesEmptyState />;
    }

    return children;
};
